import { funds } from '@/api';
// import { Toast } from 'vant';
import router from '@/router'
import axios_config from '@/axios/config.js'
import QRCode from "qrcodejs2";
import { Loading, Message, MessageBox } from 'element-ui';
// import { setTimeout } from 'timers';

// this.$prompt = MessageBox.prompt;


const cashRegister = {
  state: {
    orderId: '', //订单编号
    remark: '', //取消订单备注
    qucikPaymentChannel: '', //1网上存款,2蚂蚁钱包,3转账支付
    qrcodeCanvasId: '', //二维码ID
    source: '', // ios  android 
    // isCreadeOrderSuccess: false //订单是否创建成功
    cancelPopupShow: false, //取消弹出Popup
    cancelCause: undefined //取消订单原因
  },
  mutations: {
    setOrderId(state, data) {
      state.orderId = data;
    },
    setQucikPaymentChannel(state, data) {
      state.qucikPaymentChannel = data;
    },
    setQrcodeCanvasId(state, data) {
      state.qrcodeCanvasId = data;
    },
    setSource(state, data) {
      state.source = data;
    },
    /* setIsCreadeOrderSuccess(state, data) {
      state.isCreadeOrderSuccess = data;
    } */
    setCancelPopupShow(state, data) {
      state.cancelPopupShow = data;
    },
    setCancelCause(state, data) {
      state.cancelCause = data;
    },
  },
  actions: {
    //获取详情
    async getOrderDetail({ state, commit }, param = {}) {
      let loading;
      if (!param.loading) {
        loading = Loading.service({
          text: '加载中...',
        });
      }
      let data = {};
      if (!!state.orderId) {
        let res = await funds.getOrderDetail({ 'orderId': state.orderId });
        if (res.IsSuccess) {
          data = res.Data.result;
          if (!param.loading) {
            loading.close();
          }
        } else {
          Message.error(res.Data);
        }
      }
      return data;
    },
    //确认付款
    async confirmPaid({ state, commit }, param) {
      try {
        let loading = Loading.service({
          text: '提交中...',
        });
        let res = await funds.confirmationPayment({ 'orderId': state.orderId })
        if (res.IsSuccess) {
          Message({
            message: '确认订单成功！',
            type: 'success'
          });

          setTimeout(() => {
            router.push({
              name: 'cashRegisterStep',
              params: {
                orderid: state.orderId,
                qucikPaymentChannel: state.qucikPaymentChannel
              }
            });
          }, 3000);
        } else {
          Message.error(res.Data);
          loading.close();
        }
      } catch (err) {
        console.info(err);
        loading.close();
      }
    },
    //打开Popup
    async cancleOrder({ state, commit }, param) {
      commit('setCancelPopupShow', true)
    },
    //取消订单
    async cancelOrderOK({ state, commit }, param) {
      try {
        let loading = Loading.service({
          text: '提交中...',
          target: document.querySelector('.deposit')
        });
        let res = await funds.userUpdateCancelOrder({ 'orderId': state.orderId, 'cancelCauses': state.cancelCause })
        if (res.IsSuccess) {
          Message({
            message: '取消订单成功！',
            type: 'success'
          });
          setTimeout(() => {
            router.push({
              name: 'deposit'
            });
          }, 3000);
        } else {
          Message.error(res.Data);
          loading.close();
        }
        commit('setCancelPopupShow', false)
      } catch (err) {
        console.info(err);
      }
    },
    //生成二维码
    qrcodeModule({ state, commit }, param) {
      let qrcode = new QRCode(param.id, {
        width: 200, //图像宽度
        height: 200, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });

      qrcode.clear(); //清除二维码
      qrcode.makeCode(param.url); //生成另一个新的二维码
      commit('setQrcodeCanvasId', param.id)
      //setImgData
    },
    //打开支付宝
    openAlipayMethod({ state, commit }, param) {
      const deviceSystem = state.source;
      if (!!deviceSystem) {
        let imgObjSrc = document.getElementById(state.qrcodeCanvasId).querySelector('canvas').toDataURL().replace('data:image/png;base64,', '');
        if (deviceSystem == 'android' && window.android.saveimage) {
          try {
            window.android.saveimage(imgObjSrc)
          } catch (e) {
            console.log(e)
          }
        } else if (deviceSystem == 'ios') {
          window.location.href = 'xinshengtouzi://saveImage?type=base64&detail=' + imgObjSrc;
        }
      }
      setTimeout(() => {
        window.location.href = 'alipayqr://platformapi/startapp'
      }, 280)
      // location.href = "alipays://platformapi/startapp";
    },
    // 返回上一页面 兼容ios 安卓
    onGoBackIosAndroid({ state, commit }) {
      if (location.hash.indexOf('/funds/deposit') != -1) {
        const source = state.source;
        if (source == 'ios') {
          window.webkit.messageHandlers.upgradeGoBack.postMessage(JSON.stringify({ b: '1' }));
        } else if (source == 'android') {
          window.android.upgradeGoBack();
        }
      }
    },
    //在线客服
    live800() {
      var url = axios_config.BASE_LIVE800_URL;
      var h = Math.round(($(window).height() - 606) / 2);
      var w = Math.round(($(window).width() - 740) / 2);
      (typeof analysesData == 'function') && analysesData('2', '2', '');
      window.open(url, "newwindow", "top=" + h + ",left=" + w + ",height=606,width=740,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no");
      return false;
    }
  }
};

export default cashRegister;


// WEBPACK FOOTER //
// ./src/store/modules/cashRegister.js